// @flow
import React from 'react';

export default function DownloadPageView() {
  return (
    <div className="container mt-5">
      <h1>Загрузка приложения</h1>
      <p>Скачайте офлайн-версию Protec Cutter для Windows</p>
      <a
        href="https://api.app.protecstore.ru/updates/Protec%20Cutter.exe"
        className="btn btn-primary"
      >
        Скачать
      </a>
    </div>
  );
}
